var _title, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChevronDesc = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    height: "12px",
    stroke: "#1db954",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "DESC")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 4,
    y2: 15,
    x2: 8,
    x1: 0
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 15,
    y2: 4,
    x2: 16,
    x1: 8
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronDesc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-DESC.e8a1c7f7.svg";
export { ForwardRef as ReactComponent };